import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=ef5b4562&"
import script from "./RelatedProducts.vue?vue&type=script&lang=js&"
export * from "./RelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports